import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../util/api";
import swal from "sweetalert";

import Header from "../common/Header";
import HeroHand from "../assets/img/hero-hand.png";

function ContactPage() {
    const navigate = useNavigate();
    const name = useRef("");
    const email = useRef("");
    const subject = useRef("");
    const message = useRef("");
    const [loading, setLoading] = useState(false);

    async function sendMessage(e) {
        e.preventDefault();
        setLoading(true);

        const contactData = {
            name: name.current.value,
            email: email.current.value,
            subject: subject.current.value,
            message: message.current.value,
        };

        try {
            const res = await api.post("/contact/send", contactData);
            if (res.data.success) {
                swal("Message Sent!", "We will get back to you shortly.", "success", {
                    button: false,
                    timer: 2000,
                });
                e.target.reset();
            }
        } catch (err) {
            swal("Error!", "Could not send message. Please try again later.", "error", {
                button: false,
                timer: 2000,
            });
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <Header />
            <section className="hero-section">
                <div className="container">
                    <div className="gradient"></div>
                    <div className="row">
                        <div className="col text-center">
                            <h2
                                className="hero-text"
                                data-aos="fade-right"
                                data-aos-duration="2000"
                            >
                                Get in touch with us
                            </h2>
                            <p className="hero-subtext" data-aos="fade-up">
                                Have questions about our exchange rates or virtual cards?
                                Our support team is available 24/7 to assist you.
                            </p>
                        </div>
                        <div className="col d-none d-lg-block">
                            <div>
                                <img src={HeroHand} data-aos="zoom-in-up" alt="Contact support" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="exchange-section py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mb-4" data-aos="fade-right">
                            <h3 className="card-title mb-4">Send us a message</h3>
                            <form onSubmit={sendMessage}>
                                <div className="mb-3">
                                    <input
                                        type="text"
                                        ref={name}
                                        className="form-control py-3"
                                        placeholder="Your Full Name"
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <input
                                        type="email"
                                        ref={email}
                                        className="form-control py-3"
                                        placeholder="Email Address"
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <input
                                        type="text"
                                        ref={subject}
                                        className="form-control py-3"
                                        placeholder="Subject"
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <textarea
                                        ref={message}
                                        className="form-control"
                                        rows="5"
                                        placeholder="How can we help you?"
                                        required
                                    ></textarea>
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-primary w-100 py-3"
                                    disabled={loading}
                                >
                                    {loading ? "Sending..." : "Send Message"}
                                </button>
                            </form>
                        </div>

                        <div className="col-lg-6 ps-lg-5" data-aos="fade-left">
                            <h3 className="card-title mb-4">Contact Information</h3>
                            <div className="mb-4">
                                <p className="bullet-main-subtext mb-1">Office Address</p>
                                <p className="card-text text-dark">Lagos, Nigeria</p>
                            </div>
                            <div className="mb-4">
                                <p className="bullet-main-subtext mb-1">Phone Number</p>
                                <p className="card-text text-dark">+234 80 000 0000</p>
                            </div>
                            <div className="mb-4">
                                <p className="bullet-main-subtext mb-1">Email Support</p>
                                <p className="card-text text-dark">support@xtravafx.com</p>
                            </div>
                            <div className="wallet-section p-4 rounded mt-4">
                                <p className="card-title text-white h5">Operational Hours</p>
                                <p className="card-text text-white">
                                    Monday - Friday: 8:00 AM - 6:00 PM<br />
                                    Saturday: 10:00 AM - 4:00 PM<br />
                                    Online Support: 24/7
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="footer-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-12">
                            <p className="footer-header">Xtrava Africa</p>
                            <p className="footer-link"><a href="/">Home</a></p>
                            <p className="footer-link"><a href="/about">About Us</a></p>
                            <p className="footer-link"><a href="/contact">Contact Us</a></p>
                        </div>
                        <div className="col-lg-3 col-md-12">
                            <p className="footer-header">Services</p>
                            <p className="footer-link"><a href="/">Crypto Exchange</a></p>
                            <p className="footer-link"><a href="/">Virtual Cards</a></p>
                            <p className="footer-link"><a href="/">Bureau de Change</a></p>
                        </div>
                        <div className="col-lg-3 col-md-12">
                            <p className="footer-header">Support</p>
                            <p className="footer-link"><a href="/">Chat with us</a></p>
                            <p className="footer-link"><a href="mailto:support@xtravafx.com">Email us</a></p>
                        </div>
                        <div className="col-lg-3 col-md-12">
                            <p className="footer-header">Location</p>
                            <p className="footer-link">Lagos, Nigeria</p>
                            <br />
                            <p className="footer-header">Telephone</p>
                            <p className="footer-link">+2347041010050</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default ContactPage;